const DefaultAvatar = ({ name, styleArr, fontSize, className }) => {
  const getBackgroundColor = () => {
    if (!styleArr) {
      return 'linear-gradient(30deg, var(--bs-primary), var(--bs-dark))';
    }
    const [color1, color2, angle] = styleArr;
    return `linear-gradient(${angle}deg, #${color1}, #${color2})`;
  };

  return (
    <div
      className={`w-100 h-100 d-flex align-items-center justify-content-center ${className}`}
      style={{
        fontSize: fontSize || '1rem',
        background: getBackgroundColor(),
      }}
    >
      <p className="text-white fw-500 m-0">{name?.slice(0, 3)}</p>
    </div>
  );
};

export default DefaultAvatar;
